import theme from "@/theme";
import { SxProps, Theme } from "@mui/material";

interface IModalStyles {
  width?: string | number;
  height?: string | number;
}

export const styles = {
  modal: ({ width, height }: IModalStyles): SxProps<Theme> => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: width || "28.5rem",
    height: height || "auto",
    bgcolor: theme.palette.custom.mainWhite,
    boxShadow: "0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05)",
    padding: "3.25rem 2.1875rem 1.25rem 2.1875rem",
    borderRadius: "1.5rem",
    outline: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }),
  basketSvg: (size: number): SxProps<Theme> => ({
    width: size,
    height: size,
    bgcolor: "#ffe7e4",
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 auto",
    flexShrink: 0,
  }),
  title: (hasVariantPost: boolean): SxProps<Theme> => ({
    margin: "0.75rem 0",
    padding: 0,
    textAlign: "center",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: "32px",
    letterSpacing: "-2%",
    whiteSpace: hasVariantPost ? "nowrap" : "normal",
    color: "#1A1D1F",
  }),
  description: {
    fontSize: "0.9375rem",
    fontWeight: 500,
    color: "#6f767e",
    textAlign: "center",
    fontFamily: "Inter",
  } as SxProps<Theme>,
  cancelButton: {
    padding: "0",
    height: "3rem",
    color: "#1976d2",
    textTransform: "none",
    fontWeight: 500,
    width: "48%",
    minWidth: "8rem",
  } as SxProps<Theme>,
  deleteButton: {
    margin: "0",
    borderRadius: "12px",
    padding: "0",
    height: "3rem",
    bgcolor: "#f4f5f6",
    color: theme.palette.custom.secondaryRed,
    textTransform: "none",
    fontWeight: 500,
    width: "48%",
    minWidth: "8rem",
    "&:hover": {
      bgcolor: "rgba(244, 67, 54, 0.2)",
    },
  } as SxProps<Theme>,
  buttonWrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: "0px",
    marginTop: "1.5rem",
  } as SxProps<Theme>,
  closeBtn: {
    position: "absolute",
    right: "1.25rem",
    top: "1.25rem",
  } as SxProps<Theme>,
};
